import { RefreshCcw, DoorOpen, PackageCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const Label = ({ children }) => (
  <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[var(--ember)]">
    {children}
  </span>
);

const CARDS = [
  { icon: RefreshCcw, t: "Didn't deliver? Full refund.", d: "If we don't deliver what we commit to in your plan in the first month and the miss is on us — full refund. No arguments." },
  { icon: DoorOpen, t: "Exit anytime after the first month.", d: "Not a fit? Cancel after the first month. No penalties, no clawbacks." },
  { icon: PackageCheck, t: "Everything we build stays with you.", d: "Scripts, content, analytics, funnel, CRM setup — every asset we create is yours to keep, even after the engagement ends." },
];

export const Guarantees = () => (
  <section id="guarantees" className="scroll-mt-24 bg-[var(--bg-base)] py-28 md:py-36" data-testid="growth-guarantees">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="max-w-2xl">
        <Reveal><Label>Guarantees</Label></Reveal>
        <Reveal delay={80}><h2 className="mt-7 t-section">If it doesn't work, you lose nothing.</h2></Reveal>
        <Reveal delay={140}>
          <p className="mt-6 text-base leading-relaxed text-[var(--muted)] sm:text-lg">
            Three guarantees. Transparent. No fine print.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.t} delay={i * 90}>
            <div className="flex h-full flex-col rounded-2xl border border-black/5 bg-[var(--bg-contrast)] p-7">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--ember)]/10 text-[var(--ember)]">
                <c.icon size={22} strokeWidth={1.8} />
              </span>
              <h3 className="mt-6 text-lg font-semibold tracking-[-0.02em] text-[var(--ink)]">{c.t}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[var(--muted)]">{c.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
